
export type StringMap<T> = { [key: string]: T };

export function getKeys<T>(map: StringMap<T>): string[] {
  return Object.keys(map);
}

export function getValues<T>(map: StringMap<T>): T[] {
  return getKeys(map).map(key => map[key]);
}
